import { useEffect, useState } from "react";
import * as Api from "../Services/api";

import { Item } from "../Components/Item";
import { calcular, getTokenCadastro } from "../Services/api";
import { disciplinas } from "../params";
import { clsx } from "clsx";

export function Questionario({ setResultado }: { setResultado: any }) {
    const [questoes, setQuestoes] = useState([]);
    const [cadernos, setCadernos] = useState([]);
    const [linguas, setLinguas] = useState([]);
    const [valid, setValid] = useState({});
    const [caderno, setCaderno] = useState(() => {
        return "";
    });

    const [lingua, setLingua] = useState(() => {
        return "";
    });
    const [loading, setLoading] = useState(true);
    const [marcacao, setMarcacao] = useState({});

    useEffect(() => {
        setLoading(true);

        Promise.all([
            Api.fetchCadernos(),
            Api.fetchLinguas(),
        ]).then(([ cadernos, linguas ]) => {
            setCadernos(cadernos);
            setLinguas(linguas);
            setLingua(linguas[0]);
            setCaderno(cadernos[0]);

            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        if (lingua.length > 0 && caderno.length > 0) {
            Api.fetchQuestoes(caderno, lingua).then((result) => {
                setQuestoes(result);
                setMarcacao({});
                const totalCount = {};
                Object.entries(result).map(([key, value]) => {
                    totalCount[key] = value.length;
                });
            });

            window.sessionStorage.setItem("calculadora-tri-caderno", caderno);
            window.sessionStorage.setItem("calculadora-tri-lingua", lingua);
        }
    }, [lingua, caderno]);

    function handleSelecao(item: any, letra: string, key: string) {
        setMarcacao((prevState) => {
            const newState = {
                ...prevState,
                [key]: {
                    ...prevState[key],
                    [item.co_item]: {
                        id: item.id,
                        selecao: letra,
                    },
                },
            };

            const count = {};
            Object.entries(newState).forEach(([key, value]) => {
                const currentCount = Object.values(value as any).length;
                count[key] = questoes[key].length === currentCount;
            });

            return newState;
        });
    }

    function isCorreta(item: any, key: string, letra: string) {
        if (marcacao[key] && marcacao[key][item.co_item] && marcacao[key][item.co_item]['selecao']) {
            return marcacao[key][item.co_item]['selecao'] === item.tx_gabarito && letra === item.tx_gabarito;
        }

        return false;
    }

    function isTouched(item: any, key: string, letra: string) {
        const result = marcacao[key] && marcacao[key][item.co_item] && marcacao[key][item.co_item]['selecao'] === letra;

        return !!result;
    }

    function isInvalid(item: any, key: string) {
        let result = valid[key] && valid[key][item.co_item];
        result = result && (!marcacao[key] || (marcacao[key] && !marcacao[key][item.co_item]));

        return result;
    }

    function handleCalcular() {
        let isValidated = true;
        const validVerification = {};

        Object.entries(questoes).forEach(([key, val])=> {
            if (!validVerification[key]) {
                validVerification[key] = {};
            }

            val.forEach((item: any) => {
                if (!marcacao[key] || (marcacao[key] && !marcacao[key][item.co_item])) {
                    validVerification[key][item.co_item] = true;
                    isValidated = false;
                }
            });
        });

        setValid(validVerification);

        if (isValidated) {
            calcular({ ...marcacao, token: getTokenCadastro() }).then((result) => {
                if (result.success) {
                    setResultado(result.data);
                }
            });
        }
    }

    if (loading) {
        return <div>Carregando...</div>;
    }

    return <div>
        <div className="correcao-tri-form-group">
            <label htmlFor="cor">Selecione o caderno da prova</label>
            <select id="cor" onChange={(e) => setCaderno(e.target.value)}>
                <option disabled selected>Selecione o caderno da prova</option>
                { cadernos.map((caderno) => <option key={caderno} value={caderno}>{caderno}</option>) }
            </select>
        </div>

        <div className="correcao-tri-form-group">
            <label htmlFor="lingua">Selecione a língua estrangeira</label>
            <select id="lingua" onChange={(e) => setLingua(e.target.value)}>
                <option disabled selected>Selecione a língua estrangeira</option>
                { linguas.map((lingua) => <option key={lingua.key} value={lingua.key}>{lingua.value}</option>) }
            </select>
        </div>

        { Object.keys(questoes).length > 0 && <div className="correcao-tri-group">
            {Object.entries(questoes).map(([key, val]) => <div key={key}>
                <h3>{disciplinas[key]}</h3>

                <div className="correcao-tri-categoria-group">
                    {val.map((item) => {
                        const className = clsx("correcao-tri-categoria",
                            { ['correcao-tri-categoria-invalid']: isInvalid(item, key) }
                        );

                        return <div>
                            <ul data-posicao={item.co_posicao} data-gabarito={item.tx_gabarito} className={className} key={item.co_item}>
                                <li className="correcao-tri-item-posicao">{item.co_posicao}</li>
                                <Item onClick={() => handleSelecao(item, 'A', key)} touched={isTouched(item, key, 'A')} correta={isCorreta(item, key, 'A')}>A</Item>
                                <Item onClick={() => handleSelecao(item, 'B', key)} touched={isTouched(item, key, 'B')} correta={isCorreta(item, key, 'B')}>B</Item>
                                <Item onClick={() => handleSelecao(item, 'C', key)} touched={isTouched(item, key, 'C')} correta={isCorreta(item, key, 'C')}>C</Item>
                                <Item onClick={() => handleSelecao(item, 'D', key)} touched={isTouched(item, key, 'D')} correta={isCorreta(item, key, 'D')}>D</Item>
                                <Item onClick={() => handleSelecao(item, 'E', key)} touched={isTouched(item, key, 'E')} correta={isCorreta(item, key, 'E')}>E</Item>
                            </ul>
                        </div>
                })}
                </div>
            </div>)}
        </div> }

        {Object.keys(questoes).length > 0 && <div className="correcao-tri-submit">
            <button onClick={handleCalcular}>Calcular</button>
        </div> }

    </div>;
}